import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import React from 'react';
import {SingleSource,WorkItems} from '../utility';
import WorkFooter from '../components/workfooter';
import Context from '../components/context';

export default function WorkPage() {
    const workItem = WorkItems();

    return (
        <>
            <Container className='pt-5 mt-5 work'>
                <div className='subTitle text-start'>Document Management System</div>
                <h1 className='mainTitle2 text-start py-3'>{workItem.title}</h1>
                <div className='mainDes text-start pb-3'>
                Conservation Practice Document - Document Management System (CPD-DMS) is a legacy document workflow tool used by NRCS discipline specialists. 
                &nbsp;<span className='workBold'>Our goal was to migrate the platform while improving usability, clarity, and process efficiency.</span>
                </div>
                <Row className='py-5 text-start'>
                    <Col lg='3' sm='12' className='py-3'>
                        <div className='workBold2'>
                            Client
                        </div>
                        <div>
                            USDA
                        </div>
                    </Col>
                    <Col lg='3' sm='12' className='py-3'>
                        <div className='workBold2'>
                            Role
                        </div>
                        <div>
                            UX Designer
                        </div>
                    </Col>
                    <Col lg='3' sm='12' className='py-3'>
                        <div className='workBold2'>
                            Time
                        </div>
                        <div>
                            03.2023 - 07.2023
                        </div>
                    </Col>
                    <Col lg='3' sm='12' className='py-3'>
                        <div className='workBold2'>
                            Team
                        </div>
                        <div>
                            An agile team of 11
                        </div>
                    </Col>
                </Row>
            </Container>
            <section>
                <Container>
                    <Container className='work'>
                        <img alt=''width="100%" src={`/img/${workItem.assets.toLocaleLowerCase()}/cover.jpg`}/>
                        <div className='text-start pt-5 mt-5'>
                            We saw these strong results following the launch of the new CPD-DMS.
                        </div>
                        <Row className='py-5'>
                            <Col>
                                <div className='mainTitle'>
                                    30%
                                </div>
                                <div className='mt-3'>
                                    Faster Document Editing
                                </div>
                            </Col>
                            <Col>
                                <div className='mainTitle'>
                                    47%
                                </div>
                                <div className='mt-3'>
                                    Faster Approval Workflows
                                </div>
                            </Col>
                            <Col>
                                <div className='mainTitle'>
                                    200%
                                </div>
                                <div className='mt-3'>
                                    Higher New User Task Success 
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </Container>
            </section>
            <section>
                <Container className='work'>
                    <img alt=''width="100%" src={`/img/${workItem.assets.toLocaleLowerCase()}/breaker.jpg`}/>
                </Container>
            </section>
            <section>
                <Container className='work'>
                    <div className='text-start py-5 my-5'>
                        <div className='workItalic pt-5'>
                            Problem Statement
                        </div>
                        <div className='workBold3 pb-5'>
                            Aiming for a seamless user experience
                        </div>
                        <div>
                            The NRCS's CPD-DMS, built on the outdated Quark platform, 
                            <span className='workBold'> limited usability and integration. </span>
                            Our task was to migrate it to SharePoint, redesign it for efficiency, and enable direct editing in Word and streamlined communication via Outlook within the system.
                        </div>
                    </div>
                </Container>
            </section>
            <section>
                <Container className='py-5 work'>
                    <div className='breaker altbg3'>

                    </div>
                </Container>
            </section>
            <section>
                <Container className='work'>
                    <div className='text-start py-5'>
                        <div className='workItalic pt-5' id="research">
                            Research
                        </div>
                        <div className='workBold3 pb-5'>
                            Filling Gaps with Real-World User Input
                        </div>
                        <div className='pb-5'>
                            CPD-DMS supports six user roles and ten workflows, typically following a document creation → approval → publication pattern. To understand the legacy system beyond manuals and flowcharts, we conducted:
                        </div>
                        <div className='pb-5'>
                            <ul>
                                <li>
                                    <div>
                                        <span className='workBold'>Cognitive Walkthroughs</span> of legacy workflows
                                    </div>
                                </li>
                                <li>
                                    <div>
                                        <span className='workBold'>In-depth user interviews</span> across all six roles
                                    </div>
                                </li>
                                <li>
                                    <div>
                                        <span className='workBold'>Stakeholder conversations</span> with business owners and system admins
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div>
                            The research aimed to uncover:
                        </div>
                        <div className='pb-5'>
                            <ul>
                                <li>
                                    <div>
                                        Role interactions and task handoffs
                                    </div>
                                </li>
                                <li>
                                    <div>
                                        Critical vs. underused features
                                    </div>
                                </li>
                                <li>
                                    <div>
                                        Common pain points and inefficiencies
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <Row>
                            <Col className='py-2' lg xs='12'>
                                <SingleSource src={`/img/${workItem.assets.toLocaleLowerCase()}/persona_1.jpg`} />
                            </Col>
                            <Col className='py-2' lg xs='12'>
                                <SingleSource src={`/img/${workItem.assets.toLocaleLowerCase()}/persona_2.jpg`} />
                            </Col>
                            <Col className='py-2' lg xs='12'>
                                <SingleSource src={`/img/${workItem.assets.toLocaleLowerCase()}/persona_3.jpg`} />
                            </Col>
                        </Row>
                    </div>
                </Container>
            </section>
            <section>
                <Container className='work'>
                    <div className='text-start py-5'>
                        <div className='workItalic' id="user_flows">
                            User flows
                        </div>
                        <div className='workBold3 pb-5'>
                            Combined Roles and Streamlined User Flows
                        </div>
                        <div className='pb-5'>
                            Using research insights, I mapped detailed user flows and identified opportunities to combine roles, streamline approval paths, and eliminate unnecessary redundancies. This reduced complexity of the system and eased the learning curve.
                        </div>
                        <div>
                            <div className='workBold2 text-start'>
                                User flow example: Top-Current vs Bottom- Streamlined 
                            </div>
                            <div className='text-start'>
                                (This image has been intentionally pixelated due to NDA)
                            </div>
                            <SingleSource alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/user_flow.jpg`} />
                        </div>
                    </div>
                </Container>
            </section>
            <section>
                <Container className='work'>
                    <div className='text-start py-5'>
                        <div className='workItalic' id="prototype">
                            Prototype
                        </div>
                        <div className='workBold3 pb-5'>
                            Designing the Future: Streamlined and Integrated
                        </div>
                        <div className='pb-5'>
                            Based on our findings, we created a prototype that <span className='workBold'>preserved the familiarity</span> of the legacy three-pane layout and introduced major usability upgrades:
                            <br></br>
                            <br></br>
                            <ul>
                                <li>
                                    <div>
                                        <span className='workBold'>Embedded tasks directly into workflows</span>, removing the standalone task page
                                    </div>
                                </li>
                                <li className='pt-5'>
                                    <div>
                                        <span className='workBold'>Contextualized macro functions</span> (approve, route, archive) to cut clicks and reduce fatigu
                                    </div>
                                </li>
                                <li className='pt-5'>
                                    <div>
                                        <span className='workBold'>Leveraged SharePoint-Word-Outlook integration</span> for seamless editing and communication
                                    </div>
                                </li>
                            </ul>
                            <br></br>
                            These changes created a more intuitive, <span className='workBold'>role-driven experience</span> that supports document progress with minimal friction.
                        </div>
                        <div className='pb-5 mb-5'>
                            <div className='workBold2 text-start'>
                                Legacy interface example
                            </div>
                            <SingleSource alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/quark.jpg`} />
                        </div>
                        <div>
                            <div className='workBold2 text-start'>
                                New interface examples
                            </div>
                            <div className='pb-5'>
                                <SingleSource alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/sharepoint1.jpg`} />
                            </div>
                            <div className='pb-5'>
                                <SingleSource alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/sharepoint2.jpg`} />
                            </div>
                            <div>
                                <SingleSource alt='' src={`/img/${workItem.assets.toLocaleLowerCase()}/sharepoint3.jpg`} />
                            </div>
                        </div>
                    </div>
                </Container>
            </section>
            <section>
                <Container className='work'>
                    <div className='text-start py-5 my-5'>
                        <div className='workItalic' id="impact">
                            Impacts
                        </div>
                        <div className='workBold3 pb-5'>
                            Live System with Tangible Results
                        </div>
                        <div className='pb-5'>
                            The new CPD-DMS is live with strong user feedback on clearer workflows and seamless Word/Outlook integration.
                            <br></br>
                            <br></br>
                            <ul>
                                <li>
                                    <div>
                                        30% faster document editing
                                    </div>
                                </li>
                                <li>
                                    <div>
                                        47% faster approval workflows
                                    </div>
                                </li>
                                <li>
                                    <div>
                                        2x higher first-time user task success
                                    </div>
                                </li>
                            </ul>
                            <br></br>
                            “This isn't just a rebuild—it's a re-envisioning of what this system can be.” — USDA Product Owner
                            <br></br>
                            <br></br>
                            The redesign boosts current efficiency while setting a solid foundation for future USDA enhancements.
                        </div>
                    </div>
                </Container>
            </section>
            <section>
                <Container fluid className='work altbg8 py-5 mt-5'>
                    <Container className='altbg8Font work'>
                        <div className='text-start py-5 my-5'>
                            <div className='workItalic pt-5' id="takeaways">
                                Takeaways
                            </div>
                            <div className='workBold3 pb-5'>
                                Bringing Clarity and Efficiency to Government UX
                            </div>
                            <div className='pb-5'>
                                <ul>
                                    <li>
                                        <div>
                                            <span className='workBold'>User research is essential when rebuilding legacy systems.</span> Business documentation only tell part of the story—real insights come from observing how users actually interact with the system and where they struggle.
                                        </div>
                                    </li>
                                    <li className='pt-5'>
                                        <div>
                                            <span className='workBold'>Close collaboration with stakeholders accelerates alignment.</span> Working hand-in-hand with business sponsors ensured the final product balanced agency policy requirements with intuitive UX.
                                        </div>
                                    </li>
                                    <li className='pt-5'>
                                        <div>
                                            <span className='workBold'>Streamlining workflows improves more than efficiency—it empowers users.</span> By reducing complexity, we made the system more approachable and less frustrating.
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </Container>
                </Container>
            </section>
            <Container className='work workFooter'>
                <WorkFooter workPrevious={workItem.workPrevious} workPreviousTitle={workItem.workPreviousTitle} workNext={workItem.workNext} workNextTitle={workItem.workNextTitle} />
            </Container>
            <Context workPrevious={workItem.workPrevious} workNext={workItem.workNext} contextItems={workItem.contextItems} />
        </>
    );
  }